// Build "add to calendar" URLs for the major clients. Given an https://
// text/calendar URL, each function returns either a deep link the browser
// can open or a launcher URL for the hosted calendar UI.

export function googleCalendarUrl(icsUrl: string): string {
  // Empirically, Google Calendar's cid= handoff is more reliable when the
  // target is encoded with webcal:// than with https://.
  const webcal = icsUrl.replace(/^https?:\/\//, 'webcal://');
  return `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(webcal)}`;
}

export function appleCalendarUrl(icsUrl: string): string {
  // webcal:// hands off to the native Calendar app on macOS/iOS and often
  // Android too; browsers that can't handle it fall back to copy-paste.
  return icsUrl.replace(/^https?:\/\//, 'webcal://');
}

export function outlookCalendarUrl(icsUrl: string, name = 'Outside Calendar'): string {
  const params = new URLSearchParams({ url: icsUrl, name });
  return `https://outlook.office.com/calendar/0/addfromweb?${params.toString()}`;
}
